module.exports = __webpack_public_path__ + "static/media/life-redemption-banner-desktop.4617076f.jpg";